exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bi-common-NonNumericFilter .ba-common-toggleSwitch.is-right{padding:24px 24px 0}.bi-common-NonNumericFilter .ba-common-toggleSwitch__box{float:right}", ""]);

// exports
